export default function () {
  if ("datetimepicker" in window.$) {
    return Promise.resolve(true);
  }
  return import( /* webpackChunkName: "datetimepicker" */ "./index");
}
